import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

export const CTASection = () => {
  return (
    <section className="py-20 section-padding">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#003456] rounded-3xl p-12 md:p-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-1/2 h-full opacity-20">
            <img src="https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=800" alt="" className="w-full h-full object-cover" />
          </div>
          <div className="relative z-10 max-w-xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Preserve What Matters
            </h2>
            <p className="text-white/70 mb-8">
              Get started today with as low as 0% APR financing. As low as $67/month for our most popular model.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/products">
                <Button className="bg-[#fdc31c] hover:bg-[#e5b019] text-[#0a0203] font-semibold px-8 py-6 btn-scale" data-testid="cta-shop-btn">
                  Shop Now <ChevronRight className="ml-2 h-5 w-5" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button variant="outline" className="border-white text-white hover:bg-white hover:text-[#003456] px-8 py-6 btn-scale" data-testid="cta-contact-btn">
                  Talk to an Expert
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
